import { iCategory, iEvent } from "../../interfaces/iEvent";
import { CallEmsApi, iEmsApiResponse, iEmsApiResponseBody } from "./FetchExtension";

export interface GetEventsResult {
    events: iEvent[];
}

export async function GetEvents(
    userIds: number[],
    fromDate: Date,
    toDate: Date,
): Promise<iEmsApiResponseBody<GetEventsResult>> {
    const headers = new Headers();
    headers.append("userIDs", userIds.join(","));
    headers.append("fromDate", fromDate.toISOString());
    headers.append("toDate", toDate.toISOString());
    return await CallEmsApi<GetEventsResult>("GET", "Events", undefined, headers);
}

export interface GetCategoriesResult {
    categories: iCategory[];
}

export async function GetCategories(): Promise<iEmsApiResponseBody<GetCategoriesResult>> {
    return await CallEmsApi<GetCategoriesResult>("GET", "Categories");
}

export interface EventRequest {
    Title: string;
    StartTime: string;
    EndTime: string;
    Details?: string;
    UserId: number;
    CategoryId: number;
}

export async function CreateEvent(request: EventRequest): Promise<iEmsApiResponse> {
    return await CallEmsApi<never>("POST", "Events", request);
}

export async function UpdateEvent(id: number, request: EventRequest): Promise<iEmsApiResponse> {
    return await CallEmsApi<never>("PUT", `Events/${id}`, request);
}

export async function DeleteEvent(id: number): Promise<iEmsApiResponse> {
    return await CallEmsApi<never>("DELETE", `Events/${id}`);
}
